
import React,{Component} from 'react';

 import {Link} from 'react-router-dom';

 
class Usersloopcomponent extends Component{

 
render()
{
    const {data} = this.props;
    console.log(data);
    var userList = [];
    if(data.length > 0)
    {

     userList = data.map(githubUser =>
        {
            let innerObject = githubUser.githubPayload[0];
            console.log(innerObject);
            let innerKeys = Object.values(innerObject)[0];
            console.log(innerKeys);
            let userMainKeys = Object.values(innerObject)[0];


            let updateLink = `/gitsearch/updates/${githubUser.recordId}/${userMainKeys.login}/user`;
            let deleteLink = `/gitsearch/DeleteUsers/${githubUser.recordId}`;
            let eventsViewLink = `/gitsearch/users/events/${userMainKeys.login}`;
            let gistsViewLink = `/gitsearch/users/gists/${userMainKeys.login}`;
            let reposViewLink = `/gitsearch/users/repos/${userMainKeys.login}`;
            let image = userMainKeys.avatar_url;
           let createdAt = userMainKeys.created_at.split("T")[0];
           let updatedAt = userMainKeys.updated_at.split("T")[0];

            return(
            <li key={githubUser.recordId}>
          
            <img src={image} title="githubUserImage" alt={userMainKeys.login} />
            <section className="list-left">
            <h5 className="title">{userMainKeys.name}</h5>
            <span className="adprice">Username: {userMainKeys.login}</span>
            <p className="catpath">Company: {userMainKeys.company}</p>
            <p className="catpath">Blog: {userMainKeys.blog}</p>
            <p className="catpath">Location: {userMainKeys.location}</p>
            <p className="catpath">Bio: {userMainKeys.bio}</p>
            <p className="catpath">Public Repos: {userMainKeys.public_repos}</p>
            <p className="catpath">Public Gists: {userMainKeys.public_gists}</p>
            <p className="catpath">Followers: {userMainKeys.followers}</p>
            <p className="catpath">Following: {userMainKeys.following}</p>
            <p className="catpath">Profile Created: {createdAt}</p>
            <p className="catpath">Profile Updated: {updatedAt}</p>

            </section>
            <section className="list-right">
            <span className="date"><a href={userMainKeys.html_url}>View User on Github</a></span> 
            <span className="date"><Link to={updateLink}>Update Users</Link></span>
            <span className="cityname"><Link to={deleteLink}>Delete Users</Link></span>
            <span className="cityname"><Link to={gistsViewLink}>View Users Gists</Link></span>
            <span className="cityname"><Link to={eventsViewLink}>View Users Events</Link></span>
            <span className="cityname"><Link to={reposViewLink}>View Users Repos</Link></span>
            </section>
            <div className="clearfix"></div>
            </li> 
            )

        });
        
    }
return(

            
        <div>
        {userList}

        </div>   
           
);

}


}




export default Usersloopcomponent;


